/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_On_Fonts_HintInputs */

const en_wc_on_fonts_hint = /** @type {(inputs: Wc_On_Fonts_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chinese, Japanese and Korean fallback glyphs are included. To use another font, choose Add Font… at the bottom of the font menu or drop a licensed font file into the editor. Browser apps cannot automatically read your installed system fonts.`)
};

/**
* | output |
* | --- |
* | "Chinese, Japanese and Korean fallback glyphs are included. To use another font, choose Add Font… at the bottom of the font menu or drop a licensed font file ..." |
*
* @param {Wc_On_Fonts_HintInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_on_fonts_hint = /** @type {((inputs?: Wc_On_Fonts_HintInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_On_Fonts_HintInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_on_fonts_hint(inputs)
});
export { wc_on_fonts_hint as "wc.on.fonts_hint" }